<template>
    <div class="flex-center pointer pt-4 learn-skip-button" @click="skip">
        <div class="roboto-normal-18 clr-white">Пропустить обучение</div>
        <v-icon class="ml-1 opacity-max" large color="white">mdi-chevron-right</v-icon>
    </div>
</template>

<script lang='ts'>
    import { Vue } from 'vue-property-decorator'
    import { PropType } from 'vue'
import { mapActions } from 'vuex'

    export default Vue.extend({
        props: {
            
        },
        components: {

        },
        data() {
            return {
                
            }
        },
        computed: {

        },
        methods: {
            ...mapActions(['setLearned']),
            async skip() {
                if(this.$route.path === 'learn'){
                    this.$router.push('/')
                }else{
                    this.$router.push({query: ''})
                }
                await this.setLearned()
            },

        },
    })

    </script>

<style lang="scss" scoped>
    .learn-skip-button{
        font-size: 18px;
        opacity: .5;
    }

</style>
